<template>
  <div class="mt-3">Home</div>
</template>

<script>
export default {
  mounted() {
    this.$router.push('/classes');
  },
};
</script>
